import React from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import ApiTokenManagementPanel from 'shiplab-components/ApiTokenManagementPanel';
import { useDataAccessContext } from './useDataAccessContext';

const DataAccessApiTokensPage: React.FC = () => {
  const {
    apiTokens,
    apiTokensLoading,
    apiTokensError,
    isAtTokenLimit,
    createToken,
    updateToken,
    deleteToken,
  } = useDataAccessContext();

  return (
    <PhoenixDocCard className="mb-4">
      <PhoenixDocCard.Body>
        <ApiTokenManagementPanel
          apiTokens={apiTokens}
          loading={apiTokensLoading}
          error={apiTokensError}
          isAtTokenLimit={isAtTokenLimit}
          createToken={createToken}
          updateToken={updateToken}
          deleteToken={deleteToken}
        />
      </PhoenixDocCard.Body>
    </PhoenixDocCard>
  );
};

export default DataAccessApiTokensPage;
